/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiscordRelayMessageMessage,
    DiscordRelayMessageMessageFromJSON,
    DiscordRelayMessageMessageFromJSONTyped,
    DiscordRelayMessageMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * 
     * @type {DiscordRelayMessageMessage}
     * @memberof InlineObject11
     */
    message: DiscordRelayMessageMessage;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof InlineObject11
     */
    botToken: string;
}

export function InlineObject11FromJSON(json: any): InlineObject11 {
    return InlineObject11FromJSONTyped(json, false);
}

export function InlineObject11FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject11 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': DiscordRelayMessageMessageFromJSON(json['message']),
        'botToken': json['botToken'],
    };
}

export function InlineObject11ToJSON(value?: InlineObject11 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': DiscordRelayMessageMessageToJSON(value.message),
        'botToken': value.botToken,
    };
}


